import { render, staticRenderFns } from "./proyeccion.vue?vue&type=template&id=64aaf2cf&scoped=true"
import script from "./proyeccion.vue?vue&type=script&lang=js"
export * from "./proyeccion.vue?vue&type=script&lang=js"
import style0 from "./proyeccion.vue?vue&type=style&index=0&id=64aaf2cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64aaf2cf",
  null
  
)

export default component.exports